<script setup lang="ts">
import { type HTMLAttributes } from 'vue'
import { cva, type VariantProps } from 'class-variance-authority'

import { classMerge } from '../utils'

const sectionHeadingLineVariants = cva('w-[72px] h-1.5 sm:w-[88px] sm:h-2 md:w-[124px] md:h-2.5 lg:w-[220px] lg:h-4', {
  variants: {
    variant: {
      primary: 'bg-highlight-primary-accent',
      secondary: 'bg-highlight-secondary-accent',
      tertiary: 'bg-highlight-tertiary-accent',
      quarternary: 'bg-highlight-quarternary-accent'
    }
  },
  defaultVariants: {
    variant: 'tertiary'
  }
})

export type SectionHeadingLineProps = VariantProps<typeof sectionHeadingLineVariants>

defineProps<{
  variant?: SectionHeadingLineProps['variant'],
  twClass?: HTMLAttributes['class']
}>()
</script>

<template>
  <div :class="classMerge(sectionHeadingLineVariants({ variant }), twClass)">
    <slot />
  </div>
</template>
